import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Layout from "./navigation/layout";
import "./App.css";
import "./i18n/i18n";
import { createTheme, ThemeProvider } from "@mui/material";
import { darkColors } from "./theme/colors";
import { ProfileVisibilityProvider } from "./context/profile-visibility-context";
import { SnackbarProvider } from "./components/utils/SnackbarProvider";
import { UserProvider } from "./context/user-context";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { SignalRProvider } from "./context/signalR-context";
import { BetsProvider } from "./context/bets-context";

const theme = createTheme({
  typography: {
    fontFamily: "Montserrat",
  },
  palette: {
    primary: {
      main: darkColors.primary,
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: darkColors.buttonTop,
            borderStyle: "solid", // Border style must be solid for border-image to work
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: darkColors.borderGray, // Global focus color for the label text
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          color: darkColors.borderGray, // Default color
          "&.Mui-checked": {
            color: darkColors.borderGray, // Color when checked
          },
          "&.Mui-checked + .MuiSwitch-track": {
            backgroundColor: darkColors.borderGray, // Track color when checked
          },
        },
        track: {
          backgroundColor: darkColors.borderGray, // Track color by default
        },
      },
    },
  },
});
function App() {
  return (
    <ThemeProvider theme={theme}>
      <ProfileVisibilityProvider>
        <SnackbarProvider>
          <UserProvider>
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_URL}>
              <Router>
                <BetsProvider>
                  <SignalRProvider>
                    <Layout />
                  </SignalRProvider>
                </BetsProvider>
              </Router>
            </GoogleOAuthProvider>
          </UserProvider>
        </SnackbarProvider>
      </ProfileVisibilityProvider>
    </ThemeProvider>
  );
}

export default App;
